import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import rootReducer, { rtkQueryErrorLogger } from './slices';
import { authAPI } from './slices/auth';
import { viewsAPI } from './slices/views';
import { reviewsAPI } from './slices/reviews';
import { usersAPI } from './slices/users';
import { keypointsAPI } from './slices/keypoints';
import { FrameWithLabelAndPredictionapi } from './slices/predictions';
import { threeDStudyAPI } from './slices/threeDStudy';

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      authAPI.middleware,
      viewsAPI.middleware,
      reviewsAPI.middleware,
      usersAPI.middleware,
      keypointsAPI.middleware,
      FrameWithLabelAndPredictionapi.middleware,
      threeDStudyAPI.middleware,
      rtkQueryErrorLogger
    ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
